import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { CkeditorConstants } from '../../src/utils';

const {
  class: { WK_KEYWORD_REF },
  PLUGINS: { KeywordDeleteFromDocument },
  localStorageItem: { KEYWORD_DATA },
  htmlAttributes: { CLASS, ID },
  helperAttributes: { RESOURCE },
  helperAttributes: { TRACK_CHANGES_EDITING },
  elementClass: { suggestion_deletion_marker },
  event: { BACKWARD, FORWARD }
} = CkeditorConstants;

export default class KeywordDeletionFromDocumentEditing extends Plugin {
  constructor(editor) {
    super(editor);
  }

  init() {
    ['cut', 'delete'].forEach((event) => {
      this.listenTo(this.editor.editing.view.document, event, (evt, data) => {
        this.executeAction(evt, data, event);
      }, { priority: 'high' });
    });
  }

  executeAction(evt, data, event) {
    if(data){
    this.keywordRefs = [];
    this.selectedKeywordIds = [];
    this.keywordData = JSON.parse(localStorage.getItem(KEYWORD_DATA));
    this.editingRootDomElement = this.editor.editing.view.domRoots.get("main");
   
    event === 'cut' && this.cutOperation(evt, data);
    if (event === 'delete') {
      this.clickedItem = null;
      this.clickChildrenData = null;
      const selectedKeyword = this.getSelectedText();
      this.isEnabledDialog = false;
      selectedKeyword.length === 0 && this.deleteClickedKeyword(evt, data); // try to delete keyword char by char
      selectedKeyword && selectedKeyword.length > 0 && this.deleteSelectedKeyword(evt, data, selectedKeyword); //If exact keyword selected
      this.keywordRefs.length > 0 && this.editor.fire(KeywordDeleteFromDocument, { keywordRefs: this.keywordRefs, unwrapKeyword: false, selectedKeywordId: this.selectedKeywordIds, isEnabledDialog: this.isEnabledDialog  });
    } 
    }
  }

  deleteClickedKeyword(evt, data) {
    const keywordTextSuggetion = this.editor.editing.view.document.selection._selection._ranges[0].start.parent._textData;
    const clickedKeyword = this.getClickedKey(data);
    //To get clicked keyword Item on backspace or delete key press (Sometime we get data in _children attr or in parent attrs)
    clickedKeyword && clickedKeyword._children && clickedKeyword._children.length > 0 ? this.clickChildrenData = clickedKeyword._attrs : this.clickedItem = clickedKeyword && clickedKeyword.parent && clickedKeyword.parent._attrs;
    if ((this.clickedItem && this.clickedItem.get(CLASS) === WK_KEYWORD_REF || this.clickChildrenData && this.clickChildrenData.get(CLASS) === WK_KEYWORD_REF)) {
      const resourceId = this.clickedItem ? this.clickedItem.get(RESOURCE).split('/').pop() : this.clickChildrenData.get(RESOURCE).split('/').pop();
      const keywordId = this.clickedItem ? this.clickedItem.get(ID) : this.clickChildrenData.get(ID);
      this.selectedKeywordIds.push(keywordId);
      const selectedKeywordDef = this.getSelectedKeywordObj(resourceId);
      const { altLength, isSelectedPresentInAlt, idPrefPresentInDoc } = this.getKeywordAltLabels(selectedKeywordDef, keywordId);
      let keywordText = null, keywordInnerHtml = null;
      if (this.clickedItem) {
        const { innerText, innerHTML } = this.editingRootDomElement.querySelector(`[id='${this.clickedItem.get(ID)}']`);
        keywordText = innerText;
        keywordInnerHtml = innerHTML
      }
      if (this.clickChildrenData) {
        const { innerText, innerHTML } = this.editingRootDomElement.querySelector(`[id='${this.clickChildrenData.get(ID)}']`);
        keywordText = innerText;
        keywordInnerHtml = innerHTML
      }
      const deleteSuggestion = keywordInnerHtml.includes(suggestion_deletion_marker) ? true : false;
      const keywordTextContent = deleteSuggestion ? keywordTextSuggetion.length : keywordText.length;

      if (altLength === 1 && isSelectedPresentInAlt) {// if it's only one or last keyword
        // if that keyword only 1 alphabet and user press delete or back then show popup
        keywordTextContent === 1 && this.eventActions(evt, data, selectedKeywordDef);
      }
      else if (altLength === 2) {
        isSelectedPresentInAlt && idPrefPresentInDoc
          ? (keywordTextContent === 1 && this.keywordRefs.push(selectedKeywordDef))
          : (keywordTextContent === 1 && this.eventActions(evt, data, selectedKeywordDef))
      }
      else {
        keywordTextContent === 1 && this.keywordRefs.push(selectedKeywordDef);
      }
    }
  }

  chkForMultipleFlag(selectedKeyword){
    let flagForMultiple = false;
    const groupByKeyword =Object.groupBy(selectedKeyword.map(x=>x.keywordData), ({resourceId})=> resourceId);
    for (const key in groupByKeyword) {
      flagForMultiple = this.keywordData.find(x=> x.id===key).altLabels.length===groupByKeyword[key].length;
    }
    return flagForMultiple;
  }

  deleteSelectedKeyword(evt, data, selectedKeyword) {
    selectedKeyword.forEach(element => {
      let flagForMultiple = this.chkForMultipleFlag(selectedKeyword);
      const selectedKeywordDef = this.getSelectedKeywordObj(element.keywordData.resourceId);
      const keywordId = element.keywordData.keywordId;
      const { altLength, isSelectedPresentInAlt, idPrefPresentInDoc } = this.getKeywordAltLabels(selectedKeywordDef, keywordId);
      this.selectedKeywordIds.push(keywordId);
      const wholeKeywordSelected = (element.selectedText === element.keywordData.keywordText || element.selectedText.includes(element.keywordData.keywordText));
      if (altLength === 1 && isSelectedPresentInAlt) {
        //If only 1 alphabet is present and that is selected // select whole keyword/whole line which contains keyword and press backspace or delete
        wholeKeywordSelected && this.eventActions(evt, data, selectedKeywordDef);
        this.isEnabledDialog = this.isEnabledDialog || true;
      }
      else if (altLength === 2  && selectedKeyword.length === 1) {
        //If only 1 alphabet is present and that is selected // select whole keyword/whole line which contains keyword and press backspace or delete
        isSelectedPresentInAlt && idPrefPresentInDoc
          ? (wholeKeywordSelected && this.keywordRefs.push(selectedKeywordDef))
          : (wholeKeywordSelected && this.eventActions(evt, data, selectedKeywordDef))
      } else if ((altLength === 2 && flagForMultiple) || (altLength > 2 && flagForMultiple)) {
        this.eventActions(evt, data, selectedKeywordDef);
        this.isEnabledDialog = this.isEnabledDialog || true;
      }
      else {
        this.keywordRefs.push(selectedKeywordDef);
        this.isEnabledDialog = this.isEnabledDialog || false;
      }
    });
  }

  cutOperation(evt, data) {
    const selectedKeyword = this.getSelectedText();
    let isEnabledDialog = false;
    if (selectedKeyword && selectedKeyword.length > 0) {
      let flagForMultiple = this.chkForMultipleFlag(selectedKeyword);
      selectedKeyword.forEach(element => {
        if (element.selectedText.includes(element.keywordData.keywordText) || element.selectedText.length === element.keywordData.keywordText.length) {
          const selectedKeywordDef = this.getSelectedKeywordObj(element.keywordData.resourceId);
          const keywordId = element.keywordData.keywordId;
          const { altLength, isSelectedPresentInAlt, idPrefPresentInDoc } = this.getKeywordAltLabels(selectedKeywordDef, keywordId)
          this.selectedKeywordIds.push(keywordId);
          if (altLength === 1 && isSelectedPresentInAlt) {
            this.eventActions(evt, data, selectedKeywordDef)
            isEnabledDialog = isEnabledDialog || true;
          }
          else if (altLength === 2 && selectedKeyword.length === 1) {
            isSelectedPresentInAlt && idPrefPresentInDoc
              ? this.keywordRefs.push(selectedKeywordDef)
              : this.eventActions(evt, data, selectedKeywordDef);
          } else if ((altLength === 2 && flagForMultiple) || (altLength > 2 && flagForMultiple)) {
            this.eventActions(evt, data, selectedKeywordDef);
            isEnabledDialog = isEnabledDialog || true;
          }
          else {
            this.keywordRefs.push(selectedKeywordDef);
            isEnabledDialog = isEnabledDialog || false;
          }
        }
      });
    }
    if (this.keywordRefs.length > 0) {
      this.editor.fire(KeywordDeleteFromDocument, { keywordRefs: this.keywordRefs, unwrapKeyword: false, selectedKeywordId: this.selectedKeywordIds, isEnabledDialog: isEnabledDialog });
    }
  }

  getKeywordAltLabels(selectedKeywordDef, keywordId) {
    const altLength = selectedKeywordDef.altLabels.length;
    const isSelectedPresentInAlt = selectedKeywordDef.altLabels.find(
      (x) => x.id === keywordId
    );
    const idPrefPresentInDoc = Boolean(
      this.editingRootDomElement.querySelector(
        `[id='${selectedKeywordDef.altLabels[0].id}']`
      )
    );
    return { altLength, isSelectedPresentInAlt, idPrefPresentInDoc }
  }

  eventActions(evt, data, selectedKeywordDef) {
    data.preventDefault();
    evt.stop();
    this.keywordRefs.push(selectedKeywordDef);
  }

  getSelectedKeywordObj(resourceId) {
    return this.keywordData.find((item) => item.id === resourceId);
  }

  getSelectedText() {//keyword selection
    const selectedValues = [];
    for (const value of this.editor.model.document.selection.getRanges()) {
      for (const itemInSelection of value.getWalker()) {
        if (itemInSelection.item && itemInSelection.item.textNode && itemInSelection.item.textNode.parent._attrs
          && itemInSelection.item.textNode.parent.getAttribute(CLASS) === WK_KEYWORD_REF) {
          selectedValues.push(this.getSelectedKeywordValues(itemInSelection.item));
        }
      }
    }
    return selectedValues;
  }

  /**
   * Fetch the keywords present in the selection in document
   * @private
   * @param {TextProxy} item
   * @returns {*}
   */
  getSelectedKeywordValues(item) {
    return {
      keywordData: {
        keywordText: item.textNode.data,
        resourceId: item.textNode.parent.getAttribute(RESOURCE).split('/').pop(),
        keywordId: item.textNode.parent.getAttribute(ID)
      },
      selectedText: item.data
    };
  }

  getClickedKey(data) {//on click
    const selection = this.editor.model.document.selection.getFirstPosition();
    let highlightedItems;
    if (data.direction === BACKWARD && selection.nodeBefore) {
      highlightedItems = selection.nodeBefore;
    }
    else if (data.direction === FORWARD && selection.nodeAfter) {
      highlightedItems = selection.nodeAfter;
    }
    else if ((data.direction === BACKWARD || data.direction === FORWARD) && !selection.nodeAfter && !selection.nodeBefore) {
      highlightedItems = selection.textNode;
    }
    return highlightedItems;
  }
}
